import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const Triangle = props => {
  return (
    <Svg
      width={154}
      height={144}
      viewBox="0 0 154 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path opacity={0.4} d="M0 0l154 144H0V0z" fill="#4499D2" />
    </Svg>
  );
};

export default Triangle;
